import { getSvgPath } from 'figma-squircle'
import { LucideIcon } from 'lucide-react'
import { FC } from 'react'

import { cn } from '@/lib/utils'

interface AppIconProps {
  Icon: LucideIcon | FC<React.SVGProps<SVGSVGElement>>
  color: string
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const AppIcon: FC<AppIconProps> = ({ Icon, color, className = '', size = 'lg' }) => {
  const squirclePath = getSvgPath({
    width: 100,
    height: 100,
    cornerRadius: 25,
    cornerSmoothing: 0.8,
  })

  const sizeConfigs = {
    sm: {
      container: 'w-8 h-8',
      svg: 32,
      iconWrapper: 'w-5 h-5',
      icon: 'w-4 h-4',
    },
    md: {
      container: 'w-12 h-12',
      svg: 48,
      iconWrapper: 'w-7 h-7',
      icon: 'w-6 h-6',
    },
    lg: {
      container: 'w-16 h-16',
      svg: 64,
      iconWrapper: 'w-10 h-10',
      icon: 'w-8 h-8',
    },
  }

  const config = sizeConfigs[size]

  return (
    <div
      className={cn(
        'relative flex justify-center items-center group-hover:scale-105 transition-transform duration-300 transform',
        config.container,
        color === 'gray' && 'outline-1 outline-dashed outline-gray-300 rounded-2xl p-1',
        className
      )}
    >
      <svg
        width={config.svg}
        height={config.svg}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute"
      >
        <path
          d={squirclePath}
          className={`fill-${color}-50 group-hover:fill-${color}-100 transition-colors duration-300`}
        />
      </svg>
      <div className={cn('relative z-10 flex items-center justify-center', config.iconWrapper)}>
        <Icon
          className={cn(config.icon, `text-${color}-500 group-hover:text-${color}-600 transition-colors duration-300`)}
        />
      </div>
    </div>
  )
}

export default AppIcon
